module.exports = __webpack_public_path__ + "static/media/make-up_compact.5d1805f0.5d1805f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/make-up_compact.5d1805f0.jpg
// module id = 477
// module chunks = 0